export const getDisplayedAccessor = (source: string) => {
    if (source.startsWith("detail.data.")) {
        return source.replace("detail.data.", "");
    }
    return source;
};
